export enum NotificationType {
  FLOW_RATE_TOO_FAST = 'FlowRateTooFast',
  FLOW_RATE_TOO_SLOW = 'FlowRateTooSlow',
  PENDING_CONFIRMATION_INFO = 'PendingConfirmationInfo',
  PENDING_CONFIRMATION_WARNING = 'PendingConfirmationWarning',
  DRIP_CHAMBER_DETACHED = 'DripChamberDetached',
  THERAPY_JOB_ABORT_TRIGGERED = 'TherapyJobAborted',
  THERAPY_JOB_UNPAIRED_FROM_MD = 'TherapyJobUnpairedFromMonitorDevice',
  NO_VOLUME_PROVIDED = 'NoVolumeProvided',
  VOLUME_TOO_HIGH = 'VolumeTooHigh',
  THERAPY_JOB_ON_HOLD = 'TherapyJobOnHold',
  THERAPY_JOB_CANCELLED = 'TherapyJobCancelled',
  THERAPY_JOB_STOPPED = 'TherapyJobStopped',
  THERAPY_JOB_ENTERED_IN_ERROR = 'TherapyJobEnteredInError',
  THERAPY_JOB_UPDATED = 'TherapyJobUpdated',
  THERAPY_JOB_MARK_FOR_DELETION = 'TherapyJobMarkForDeletion',
  DEVICE_DISCONNECTED = 'DeviceDisconnected',
  PATIENT_DISCHARGED = 'PatientDischarged',
  PATIENT_NOT_ADMITTED = 'PatientNotAdmitted',
  INFUSION_IN_ERROR = 'InfusionInError'
}
